<!--
  name : 김혜진
  desc : 워터마크 첨부
  date : 2020-09-21
-->
<template>
<div>
  <v-dialog
    v-model="dialogMark"
    max-width="1200">
      <v-card id="popStyle03">
      <!--팝업 제목-->
      <v-card-title class="title">
        워터마크 첨부
        <v-btn fab class="popBtnClose" @click="close()"></v-btn>
      </v-card-title>
      <!--/팝업 제목-->
      <!--팝업 내용-->
        <v-card-text class='scrollYst mark_scrollCon'>
          <v-row no-gutters class="justify-center popCon scrollYst_con">
          <!-- 워터마크 선택 창 -->
          <v-col cols="12" sm="12" md="6" lg="8" class="popMark_view_col">
            <v-row no-gutters class="popMark_view mt-0">
              <div class="wm-contract-container" align="center" style="overflow:hidden; height:auto; border:1px solid #dbdce1; float: left">
              <swiper :options="swiperOption" ref="contractSwiper">
                <swiper-slide v-for="(thumbnail, pindex) in contractThumbnail.thumbnail" :key="pindex">
                <!-- <v-lazy-image
                :src="thumbnail.url"
                :srcset="thumbnail.url"
                width="399px"
                height="560px"
                style="pointer-events: none;">
                </v-lazy-image> -->
                <!-- <img :src="thumbnail.url" width="399px" height="560px" style="pointer-events: none;"> -->
                    <img :id="'img-' + pindex" :src="thumbnail.url">
                    <vue-draggable-resizable
                    :w="100"
                    :h="100"
                    :minw="30"
                    :minh="30"
                    @dragging="onDrag"
                    @resizing="onResize"
                    @activated="onActive(cindex)"
                    @deactivated="onDeactivate(cindex)"
                    :parent="true"
                    v-show="showWm"
                    v-if="watermarks[pindex].length !== 0"
                    v-model="watermarks[pindex][cindex]"
                    v-for="(watermark, cindex) in watermarks[pindex]" :key="cindex">
                    <div :class="'pdfWatermark' + pindex + '-' + cindex" :width="watermark.width" :height="watermark.height" style="cursor: pointer;border: 1px dotted gray;"></div>
                    <!-- <el-button size="mini" round type="danger" icon="el-icon-delete" style="float: right" @click="deleteWatermark(cindex)"></el-button> -->
                    </vue-draggable-resizable>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
              </div>
            </v-row>
          </v-col>
          <!-- /워터마크 선택 창 -->
          <v-col cols="12" sm="12" md="6" lg="4">
            <v-row no-gutters>
              <v-col cols="12" class="btnBox_mg_tbr">
                <v-btn class="btn18_00" outlined @click="signVisible = true">전자서명 등록</v-btn>
                <v-btn  class="btn18_00" outlined @click="selectWatermark">등록된 워터마크 선택</v-btn>
                <v-file-input v-model="files" class="inputH48_01 Wm310xx mt-5" outlined accept="image/*"
                v-if="signal !== 'BROKER'"
                :before-upload="beforeUpload" label="워터마크 직접 업로드" placeholder=" " @change="uploadWatermark" >
                  </v-file-input>
            <v-checkbox
              v-model="contract.isAllPage"
              label="모든 페이지 삽입"
              @change="changeAllPageCheck"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" class="btnBox_mg_lr_none">
            <v-btn class="btn18_00" outlined @click="initWatermark">워터마크 초기화</v-btn>
            <v-btn class="btn18_00" outlined @click="downloadContract">계약서 미리보기</v-btn>
          </v-col>
          <v-col cols="12">
            <ul class="pop_info_ul">
              <li>워터마크는 드래그 하여 크기와 위치를 지정 할 수 있습니다. (QR코드는 오른쪽 상단에 고정됩니다)</li>
              <li>[모든 페이지 삽입]은 계약서 미리보기에서 확인할 수 있습니다.</li>
              <li v-if="contractStatus === 'OFFICE'">- 사내계약은 계약서 1건에 워터마크를 첨부 하면 나머지 사내계약서에 워터마크가 일괄 등록됩니다.</li>
            </ul>
          </v-col>
           </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!--/팝업 내용-->
      <!--팝업 버튼-->
      <v-card-actions class="justify-center">
        <v-btn text @click="createWatermarkPdf">확인</v-btn>
        <v-btn text @click="close()">취소</v-btn>
      </v-card-actions>
      <!--/팝업 버튼-->
    </v-card>
  </v-dialog>
  <v-dialog :title="signal === 'BROKER' ? '기업 워터마크 선택' : '개인 워터마크 선택'" width="440px"  v-model="selWmVisible">
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          전자서명 등록
        <v-btn fab class="popBtnClose" @click="signVisibleClose"></v-btn>
        </v-card-title>
        <!--/팝업 제목-->
        <!--팝업 내용-->
        <v-card-text class='scrollYst savemark_scrollCon'>
          <v-carousel v-if="wmList.length !== 0" :interval="4000" type="card" height="200px">
            <v-carousel-item v-for="watermark in wmList" :key="watermark.id">
              <v-card class="wm-watermark-card">
                <div v-if="wmList.length !== 0">
                  <img :src="watermark.url" class="wm-watermark-img" @click="clickWm(watermark.originUrl, watermark.id)">
                </div>
              </v-card>
            </v-carousel-item>
          </v-carousel>
          <v-row no-gutters v-else class="wm-empty-container popCon">
            {{ signal === 'BROKER' ? '기업' : '개인' }} 워터마크가 없습니다. 계약 정보 설정에서 등록해주세요.
          </v-row>
        </v-card-text>
      <!--/팝업 내용-->
      <!--팝업 버튼-->
        <v-card-actions class="wm-sig-btn-container justify-center">
          <v-btn size="medium" @click="selWmVisibleClose">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--전자서명 등록-->
  <v-dialog width="440px"  v-model="signVisible">
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          전자서명 등록
        <v-btn fab class="popBtnClose" @click="signVisibleClose"></v-btn>
        </v-card-title>
        <!--/팝업 제목-->
        <!--팝업 내용-->
        <v-card-text class='scrollYst savemark_scrollCon'>
            <insert-signature ref="signature" :visibleCheckBox='true'></insert-signature>

        </v-card-text>
      <!--/팝업 내용-->
      <!--팝업 버튼-->
      <v-card-actions class="justify-center">
        <v-btn text @click="registSignature">확인</v-btn>
        <v-btn text @click="signVisibleClose">닫기</v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>
    <!--/전자서명 등록-->
  <s-confirm ref="confirm"></s-confirm>
  <s-loading ref="loading"></s-loading>
</div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import VueDraggableResizable from 'vue-draggable-resizable'
import insertSignature from '@/components/signature'
import { getWaterMarkList, createContract, createBarcode, createContractThumbnail, directUploadWm, registSignature, deleteContractThumbnail } from '@/api/contract/insertWatermark'

window.onresize = function (event) {
  var ctrContainer = document.getElementsByClassName('wm-contract-container')[0]
  // var btnContainer = document.getElementsByClassName('wm-btn-container')[0]
  if (window.innerWidth < 1759) {
    ctrContainer.style.float = ''
    // btnContainer.style.float = ''
    // btnContainer.style.width = '600px'
    ctrContainer.style.marginLeft = 'auto'
    ctrContainer.style.marginRight = 'auto'
  } else {
    ctrContainer.style.float = 'left'
    // btnContainer.style.float = 'left'
    // btnContainer.style.width = '45%'
    ctrContainer.style.marginLeft = 'auto'
    ctrContainer.style.marginRight = '20px'
  }
}

var URL = {
  thumbnail: process.env.VUE_APP_URL_THUMBNAIL,
  watermark: process.env.VUE_APP_URL_WATERMARK,
  insertBarcode: process.env.VUE_APP_URL_INSERT_BARCODE,
  fileDownload: process.env.VUE_APP_URL_CONVERT_FILE_DOWNLOAD,
  contractPageThumbnail: process.env.VUE_APP_URL_CONTRACT_PAGE_THUMBNAIL
}

export default {
  name: 'popMark',
  components: {
    VueDraggableResizable,
    swiper,
    swiperSlide,
    insertSignature
  },
  props: {
    // contractStatus가 OFFICE(사내계약) 일 때 사용하는 파라미터 (사내계약이면 해당 그룹아이디, 아니면 -1)
    groupId: Number,
    // 바코드: 계약번호
    contractNum: String,
    // 임시폴더에 넣어진 PDF 파일 이름
    pdfFileName: String,
    // 계약서 요청 상태
    contractStatus: String,
    // 기업 / 개인 계약 구분
    signal: String,
    contractDetailInfo: [Object, String]
  },
  filters: {
  },
  data () {
    return {
      fileDownload: process.env.VUE_APP_URL_CONVERT_FILE_DOWNLOAD,
      dialogMark: false,
      x: 0,
      y: 0,
      isOrgUsr: 0,
      activeName: '',
      // 계약서 썸네일
      contractThumbnail: {
        pageSize: null,
        thumbnail: []
      },
      // 워터마크를 넣기 위한 계약서 설정 정보
      contract: {
        isAllPage: false,
        pdfFileName: null,
        contractPage: null,
        contractStatus: null,
        groupId: 0,
        pageRatios: null,
        addr: null
      },
      // 워터마크들
      watermarks: [],
      // 페이지 안의 워터마크 인덱스
      currIndex: null,
      // 계약서 현재 페이지
      currPage: 0,
      // 워터마크 투명도
      opacity: 100,
      // 저장된 워터마크 리스트
      wmList: [],
      selWmVisible: false,
      showWm: false,
      showSlider: false,
      loading: false,
      loadingMessage: null,
      // swiper 옵션
      swiperOption: {
        autoHeight: true,
        simulateTouch: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      // 전자서명 다이얼로그 활성화 여부
      signVisible: false,
      files : ''
    }
  },
  created () {
    this.doIntersectObserver()
    var orgname = this.$store.state.user.orgname
    if (orgname) {
      this.activeName = 'company'
      this.isOrgUsr = 1
    } else {
      this.activeName = 'personal'
      this.isOrgUsr = 0
    }
  },
  mounted () {
    var ctrContainer = document.getElementsByClassName('wm-contract-container')[0]
    // var btnContainer = document.getElementsByClassName('wm-btn-container')[0]
    if (window.innerWidth < 1759) {
      ctrContainer.style.float = ''
      // btnContainer.style.float = ''
      // btnContainer.style.width = '600px'
      ctrContainer.style.marginLeft = 'auto'
      ctrContainer.style.marginRight = 'auto'
    } else {
      ctrContainer.style.float = 'left'
      // btnContainer.style.float = 'left'
      // btnContainer.style.width = '45%'
      ctrContainer.style.marginLeft = 'auto'
      ctrContainer.style.marginRight = '20px'
    }
  },
  methods: {
    open () {
      this.dialogMark = true
      this.$nextTick(() => {
        this.createContractThumbnail()
      })
      /*
      var ctrContainer = document.getElementsByClassName('wm-contract-container')[0]
      var btnContainer = document.getElementsByClassName('wm-btn-container')[0]
      if (window.innerWidth < 1759) {
        ctrContainer.style.float = ''
        btnContainer.style.float = ''
        btnContainer.style.width = '600px'
        ctrContainer.style.marginLeft = 'auto'
        ctrContainer.style.marginRight = 'auto'
      } else {
        ctrContainer.style.float = 'left'
        btnContainer.style.float = 'left'
        btnContainer.style.width = '45%'
        ctrContainer.style.marginLeft = 'auto'
        ctrContainer.style.marginRight = '20px'
      }
      */
    },
    close () {
      this.dialogMark = false
    },
    beforeUpload (file) {
      const isImage = (file.type).indexOf('image') !== -1
      const isLt5M = (file.size / 1024 / 1024) < 5
      if (!isImage) {
        /* this.$message.error('IMAGE 파일만 올려주세요.') */
        this.$refs.confirm.open('alert', '워터마크 업로드', 'IMAGE 파일만 올려주세요.')
      } else if (!isLt5M) {
        /* this.$message.error('5MB 미만의 파일만 올려주세요.') */
        this.$refs.confirm.open('alert', '워터마크 업로드', '5MB 미만의 파일만 올려주세요.')
      }
      return isImage && isLt5M
    },
    beforeLeave () {
      if (this.isOrgUsr !== 1) {
        this.$refs.confirm.open('alert', '사용자 권한', '등록된 기업이 없습니다. 기업정보를 설정해 주세요')
      }
      return this.isOrgUsr !== 0
    },
    changeAllPageCheck (value) {
      var isCompareEachPage = false
      var firstPageWidth = document.getElementById('img-' + 0).clientWidth
      var firstPageHeight = document.getElementById('img-' + 0).clientHeight
      for (var i = 0; i < this.watermarks.length; i++) {
        var page = document.getElementById('img-' + i)
        if (firstPageWidth !== page.clientWidth && firstPageHeight !== page.clientHeight) {
          isCompareEachPage = true
          break
        }
      }
      if (isCompareEachPage) {
        this.$refs.confirm.open('alert', '워터마크 첨부', '업로드한 계약서의 각 페이지의 사이즈가 서로 달라서 모든 페이지 삽입 기능은 사용 할 수 없습니다.')
        this.contract.isAllPage = !value
      }
    },
    doIntersectObserver () {
      // v-lazy-loading에서 사용, 원래는 element의 상태를 감시
      // 하지만 별 필요없어서 초기화만 해줌(IE에 없어서 추가)
      const config = {
        root: null, // 'root' 속성이 없거나 'null'로 설정하면 기본 값은 뷰포트가 된다.
        rootMargin: '0px',
        threshold: 0.5
      }
      var io = new IntersectionObserver(function (entries) {
      }, config)
      io.POLL_INTERVAL = 100
    },
    handleClick (tab, event) {
      if (tab.paneName === 'company') {
        this.activeName = 'company'
        this.wmList = []
        this.getWatermarkList()
      } else {
        this.activeName = 'personal'
        this.wmList = []
        this.getWatermarkList()
      }
    },
    // 투명도 지정
    opacityChange (value) {
      var pageIndex = this.$refs.contractSwiper.swiper.realIndex
      var pdfWatermark = document.getElementsByClassName('pdfWatermark' + pageIndex + '-' + this.currIndex)[0]
      pdfWatermark.style.opacity = (value / 100)
      this.watermarks[pageIndex][this.currIndex].opacity = value
    },
    // 워터마크 클릭 시
    onActive (index) {
      this.showSlider = true
      this.currIndex = index
      this.currPage = this.$refs.contractSwiper.swiper.realIndex
      this.opacity = this.watermarks[this.currPage][this.currIndex].opacity
    },
    // 워터마크 클릭이 해제됐을 때
    onDeactivate (index) {
    },
    // 워터마크 리사이즈
    onResize: function (x, y, width, height) {
      var pageIndex = this.$refs.contractSwiper.swiper.realIndex
      this.$nextTick(() => {
        if (this.currIndex === null) {
          this.currIndex = 0
        }
        // pt
        this.watermarks[pageIndex][this.currIndex].x = x
        this.watermarks[pageIndex][this.currIndex].y = y

        // mm
        this.watermarks[pageIndex][this.currIndex].width = width
        this.watermarks[pageIndex][this.currIndex].height = height
        var pdfWatermark = document.getElementsByClassName('pdfWatermark' + pageIndex + '-' + this.currIndex)[0]
        pdfWatermark.style.width = width + 'px'
        pdfWatermark.style.height = height + 'px'
        pdfWatermark.style.backgroundSize = width + 'px ' + height + 'px'
      })
    },
    onDrag: function (x, y) {
      this.x = x
      this.y = y
      var pageIndex = this.$refs.contractSwiper.swiper.realIndex
      this.$nextTick(() => {
        this.watermarks[pageIndex][this.currIndex].x = x
        this.watermarks[pageIndex][this.currIndex].y = y
      })
    },
    getWatermarkList () {
      if (this.signal === 'BROKER') {
        this.activeName = 'company'
      } else {
        this.activeName = 'personal'
      }
      this.$nextTick(() => {
        getWaterMarkList(JSON.stringify({ activeName: this.activeName })).then(response => {
          this.wmList = []
          for (var k in response.rdata.watermarks) {
            this.wmList.push({
              id: response.rdata.watermarks[k].watermarkSequence,
              url: URL.thumbnail + response.rdata.watermarks[k].watermarkSequence,
              originUrl: URL.watermark + response.rdata.watermarks[k].watermarkSequence
            })
          }
        }).catch(e => {
          console.log(e)
        })
      })
    },
    selectWatermark () {
      this.selWmVisible = true
      this.getWatermarkList()
    },
    beforeCreateContract () {
      this.createContract()
      return 1
    },
    createContract () {
      var paramWatermarks = []
      var pageRatios = []
      for (var i = 0; i < this.watermarks.length; i++) {
        for (var k = 0; k < this.watermarks[i].length; k++) {
          paramWatermarks.push(this.watermarks[i][k])
        }
        var page = document.getElementById('img-' + i)
        pageRatios.push({ page: i + 1, pageWidthRatio: 792 / page.clientWidth, pageHeightRatio: 1120 / page.clientHeight })
      }
      this.contract.contractPage = paramWatermarks
      this.contract.pdfFileName = this.pdfFileName
      this.contract.contractNum = this.contractNum
      this.contract.contractStatus = this.contractStatus
      this.contract.groupId = this.groupId
      this.contract.pageRatios = pageRatios
      this.contract.addr = this.contractDetailInfo.chainAddress
      if (paramWatermarks.length !== 0) {
        createContract(JSON.stringify(this.contract)).then(response => {
          if (response.rcode === 20000) {
            this.$store.dispatch('convertPdfName', response.rdata.convertPdfName)
            this.$store.dispatch('watermarkAttach', true)
          } else {
            this.$refs.confirm.open('alert', '워터마크 첨부', '계약서파일 생성 요청에 실패했습니다.')
          }
        }).catch(e => {
          this.$refs.confirm.open('alert', '워터마크 첨부', '계약서파일 생성 요청에 실패했습니다.')
          console.log(e)
        })
      } else {
        this.$store.dispatch('convertPdfName', 'empty')
        this.$store.dispatch('watermarkAttach', false)
        this.$refs.confirm.open('alert', '계약서 생성 요청', '등록한 워터마크가 없어서 변환을 하지않습니다.')
      }
      return 1
    },
    clickWm (url, id) {
      this.showWm = true
      var pageIndex = this.$refs.contractSwiper.swiper.realIndex
      // id에도 계약 번호 넣어줘야할듯
      this.watermarks[pageIndex].push({ id: id, width: 100, height: 100, x: 0, y: 0, opacity: 100, isBarcode: 0, pageNum: pageIndex + 1 })
      // 이유는 모르겠으나.. 자동으로 배열의 변경을 감지하지 못해서 강제로 Vue인스턴스를 강제로 렌더링하게 해주는 메소드
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$refs.confirm.open('alert', '워터마크 첨부', '직접 서명 시, 반드시 알맞은 서명 위치로 배치해 주세요.')
        var currPageWmLength = 0
        currPageWmLength = this.getCurrPageWmLength()
        this.currIndex = currPageWmLength
        /* 동적으로 background-img를 넣어주는 부분 */
        var pdfWatermark = document.getElementsByClassName('pdfWatermark' + pageIndex + '-' + currPageWmLength)[0]
        // console.log(pdfWatermark)
        pdfWatermark.style.width = this.watermarks[pageIndex][currPageWmLength].width + 'px'
        pdfWatermark.style.height = this.watermarks[pageIndex][currPageWmLength].height + 'px'
        pdfWatermark.style.backgroundSize = this.watermarks[pageIndex][currPageWmLength].width + 'px ' + this.watermarks[pageIndex][currPageWmLength].height + 'px'
        pdfWatermark.style.backgroundImage = 'url("' + url + '")'
        pdfWatermark.style.backgroundRepeat = 'no-repeat'
        this.selWmVisible = false
      })
    },
    deleteWatermark (index) {
      this.currIndex = null
      this.$nextTick(() => {
        var pageIndex = this.$refs.contractSwiper.swiper.realIndex
        // 현재 예를 들어 배열 사이즈가 3인 배열이 있다고 하면 1, 2, 3에서 2를 지우면 3부터 지워짐 1을 지워도 3부터 차례대로 뒤부터 지워지는 현상이 있음
        this.watermarks[pageIndex].splice(index, 1)
        // 이유는 모르겠으나.. 자동으로 2차원 배열의 변경을 감지하지 못해서 강제로 Vue인스턴스를 강제로 렌더링하게 해주는 메소드
        this.$forceUpdate()
      })
    },
    initWatermark () {
      this.showSlider = false
      // 올라가 있는 모든 워터마크 및 바코드 삭제
      this.$nextTick(() => {
        var pageIndex = this.$refs.contractSwiper.swiper.realIndex
        this.watermarks.splice(0, this.watermarks[pageIndex].length)
        for (var i = 0; i < this.contractThumbnail.pageSize; i++) {
          this.watermarks[i] = []
        }
        // this.watermarks.splice(0, pageIndex)
        // 이유는 모르겠으나.. 자동으로 배열의 변경을 감지하지 못해서 강제로 Vue인스턴스를 강제로 렌더링하게 해주는 메소드
        this.$forceUpdate()
      })
    },
    insertBarcode () {
      createBarcode(JSON.stringify({ contractNum: this.contractNum })).then(response => {
        var currPageWmLength = 0
        this.showWm = true
        // 현재 swiper 페이지 인덱스
        var pageIndex = this.$refs.contractSwiper.swiper.realIndex
        // id에도 계약 번호 넣어줘야할듯
        this.watermarks[pageIndex].push({ id: this.contractNum, width: 50, height: 50, x: 0, y: 0, opacity: 50, isBarcode: 1, pageNum: 1 })

        // 이유는 모르겠으나.. 자동으로 2차원 배열의 변경을 감지하지 못해서 강제로 Vue인스턴스를 강제로 렌더링하게 해주는 메소드
        this.$forceUpdate()
        this.$nextTick(() => {
          currPageWmLength = this.getCurrPageWmLength()
          this.currIndex = currPageWmLength
          // 동적으로 background-img를 넣어주는 부분
          var pdfWatermark = document.getElementsByClassName('pdfWatermark' + pageIndex + '-' + currPageWmLength)[0]
          pdfWatermark.style.width = this.watermarks[pageIndex][currPageWmLength].width + 'px'
          pdfWatermark.style.height = this.watermarks[pageIndex][currPageWmLength].height + 'px'
          pdfWatermark.style.backgroundSize = this.watermarks[pageIndex][currPageWmLength].width + 'px ' + this.watermarks[pageIndex][currPageWmLength].height + 'px'
          // 계약번호 넣어줘야할듯
          pdfWatermark.style.backgroundImage = 'url(' + URL.insertBarcode + this.contractNum + ')'
          pdfWatermark.style.backgroundRepeat = 'no-repeat'
          this.selWmVisible = false
        })
      }).catch(e => {
        console.log(e)
      })
    },
    uploadWatermark (event) {
      const data = new FormData()
      data.append('file', this.files)
      directUploadWm(data).then(response => {
        if (response.rcode === 20000) {
          this.$refs.confirm.open('alert', '워터마크 첨부', '직접 서명 시, 반드시 알맞은 서명 위치로 배치해 주세요.')
          var currPageWmLength = 0
          this.showWm = true
          // 현재 swiper 페이지 인덱스
          var pageIndex = this.$refs.contractSwiper.swiper.realIndex
          var fileName = response.rdata.fileName
          // id에도 계약 번호 넣어줘야할듯a
          this.watermarks[pageIndex].push({ id: fileName, width: 100, height: 100, x: 0, y: 0, opacity: 100, isBarcode: 2, pageNum: pageIndex + 1 })
          // 이유는 모르겠으나.. 자동으로 2차원 배열의 변경을 감지하지 못해서 강제로 Vue인스턴스를 강제로 렌더링하게 해주는 메소드
          this.$forceUpdate()
          this.$nextTick(() => {
            currPageWmLength = this.getCurrPageWmLength()
            this.currIndex = currPageWmLength
            /* 동적으로 background-img를 넣어주는 부분 */
            var pdfWatermark = document.getElementsByClassName('pdfWatermark' + pageIndex + '-' + currPageWmLength)[0]
            pdfWatermark.style.width = this.watermarks[pageIndex][currPageWmLength].width + 'px'
            pdfWatermark.style.height = this.watermarks[pageIndex][currPageWmLength].height + 'px'
            pdfWatermark.style.backgroundSize = this.watermarks[pageIndex][currPageWmLength].width + 'px ' + this.watermarks[pageIndex][currPageWmLength].height + 'px'
            // 계약번호 넣어줘야할듯
            pdfWatermark.style.backgroundImage = 'url(' + URL.insertBarcode + fileName + ')'
            pdfWatermark.style.backgroundRepeat = 'no-repeat'
            this.selWmVisible = false
          })
        }
      })
    },
    downloadContract () {
      this.$refs.loading.start('계약서 미리보기를 생성 중입니다.')
      var paramWatermarks = []
      var pageRatios = []
      for (var i = 0; i < this.watermarks.length; i++) {
        for (var k = 0; k < this.watermarks[i].length; k++) {
          paramWatermarks.push(this.watermarks[i][k])
        }
        var page = document.getElementById('img-' + i)
        pageRatios.push({ page: i + 1, pageWidthRatio: 792 / page.clientWidth, pageHeightRatio: 1120 / page.clientHeight })
      }
      this.contract.contractPage = paramWatermarks
      this.contract.pdfFileName = this.pdfFileName
      this.contract.contractNum = this.contractNum
      this.contract.contractStatus = 'TEMP-' + this.contractStatus
      this.contract.groupId = this.groupId
      this.contract.pageRatios = pageRatios
      createContract(JSON.stringify(this.contract)).then(response => {
        this.$nextTick(() => {
          this.$refs.loading.end()
          var convertPdfName = response.rdata.convertPdfName
          if (convertPdfName) {
            const popup = window.open(this.fileDownload + convertPdfName)
            /* deletePDFfile({convertPdfName: convertPdfName}).then(response => {
             console.log(response.rdata.success)
             }) */
            if (popup === null) {
              this.$refs.confirm.open('alert', '계약서 미리보기', '이 페이지에서 팝업이 차단되어 있습니다. 계약서 미리보기를 하려면 팝업을 허용해주세요.')
              return false
            }
          } else {
            /* this.$message.error('PDF 파일이 없거나 경로가 잘못되었습니다.') */
            this.$refs.confirm.open('alert', '계약서 미리보기', 'PDF 파일이 없거나 경로가 잘못되었습니다.')
          }
        })
      })
    },
    createContractThumbnail () {
      this.$refs.loading.start('계약서 썸네일을 생성 중입니다.')
      this.$nextTick(() => {
        createContractThumbnail(JSON.stringify({ pdfFileName: this.pdfFileName })).then(response => {
          this.$refs.loading.end()
          this.contractThumbnail.pageSize = response.rdata.pdfPageSize
          for (var i = 0; i < this.contractThumbnail.pageSize; i++) {
            this.watermarks[i] = []
          }
          this.$forceUpdate()
          this.getContractThumbnail()
        }).catch(e => {
          console.log(e)
        })
      })
    },
    getContractThumbnail () {
      this.loading = false
      this.contractThumbnail.thumbnail.splice(0, this.contractThumbnail.thumbnail.length)
      for (let i = 0; i < this.contractThumbnail.pageSize; i++) {
        this.contractThumbnail.thumbnail.push(
          { url: URL.contractPageThumbnail + this.pdfFileName + '/' + i }
        )
      }
      this.deleteContractThumbnail()
    },
    // 워터마크 다이얼로그를 닫았을 때 생성됐던 썸네일 폴더 및 하위 파일들을 삭제해주는 기능
    deleteContractThumbnail () {
      setTimeout(() => {
        deleteContractThumbnail(JSON.stringify({ pdfFileName: this.pdfFileName })).then(response => {
          this.$forceUpdate()
        }).catch(e => {
        })
      }, 1000)
    },
    getCurrPageWmLength () {
      var pageIndex = this.$refs.contractSwiper.swiper.realIndex
      var currPageWmLength = 0
      for (var i = 0; i < this.watermarks.length; i++) {
        currPageWmLength += this.watermarks[i].length
      }
      currPageWmLength = currPageWmLength - (currPageWmLength - this.watermarks[pageIndex].length) - 1

      return currPageWmLength
    },
    parentDialogClose () {
      // console.log(this.$parent.$options)
    },
    // 전자서명 다이얼로그에서 전자서명 등록하는 부분
    registSignature () {
      var data = this.$refs.signature.save()
      if (data.data) {
        this.$refs.loading.start('전자 서명을 생성중입니다.')
        registSignature({ isWatermark: data.signToWatermark, activeName: this.signal, signBase64: data.data }).then(response => {
          this.$refs.loading.end()
          this.$refs.confirm.open('alert', '워터마크 첨부', '직접 서명 시, 반드시 알맞은 서명 위치로 배치해 주세요.')
          this.signVisible = false
          var currPageWmLength = 0
          this.showWm = true
          // 현재 swiper 페이지 인덱스
          var pageIndex = this.$refs.contractSwiper.swiper.realIndex
          var fileName = response.rdata.signFileName
          // id에도 계약 번호 넣어줘야할듯
          this.watermarks[pageIndex].push({ id: fileName, width: 100, height: 100, x: 0, y: 0, opacity: 100, isBarcode: 2, pageNum: pageIndex + 1 })
          // 이유는 모르겠으나.. 자동으로 2차원 배열의 변경을 감지하지 못해서 강제로 Vue인스턴스를 강제로 렌더링하게 해주는 메소드
          this.$forceUpdate()
          this.$nextTick(() => {
            currPageWmLength = this.getCurrPageWmLength()
            this.currIndex = currPageWmLength
            /* 동적으로 background-img를 넣어주는 부분 */
            var pdfWatermark = document.getElementsByClassName('pdfWatermark' + pageIndex + '-' + currPageWmLength)[0]
            pdfWatermark.style.width = this.watermarks[pageIndex][currPageWmLength].width + 'px'
            pdfWatermark.style.height = this.watermarks[pageIndex][currPageWmLength].height + 'px'
            pdfWatermark.style.backgroundSize = this.watermarks[pageIndex][currPageWmLength].width + 'px ' + this.watermarks[pageIndex][currPageWmLength].height + 'px'
            pdfWatermark.style.backgroundImage = 'url(' + URL.insertBarcode + fileName + ')'
            pdfWatermark.style.backgroundRepeat = 'no-repeat'
            this.selWmVisible = false
          })
        }).catch(e => {
          console.error(e)
        })
      }
    },
    // [워터마크] 워터마크 다하고 나서 확인 눌렀을 때 호출되는 함수
    createWatermarkPdf () {
      this.$store.dispatch('convertPdfName', '')
      this.$store.dispatch('watermarkAttach', false)
      this.beforeCreateContract()
      this.loopSleep()
    },
    loopSleep () {
      this.$refs.loading.start('계약서에 워터마크를 삽입중입니다.')
      setTimeout(() => {
        if (this.$store.state.app.convertPdfName) {
          this.$refs.loading.end()
          this.$emit('child', this.$store.state.app.watermarkAttach)
          this.dialogMark = false
        } else {
          this.loopSleep()
        }
      }, 500)
    },
    signVisibleClose () {
      this.$refs.confirm.open('confirm', '전자서명', '현재 창을 닫으시면 작성한 전자서명이 지워집니다. 그래도 닫으시겠습니까?').then(() => {
        this.$refs.signature.initSignaturePad()
        this.signVisible = false
      })
    },
    signBeforeClose () {
      this.$refs.confirm.open('confirm', '전자서명', '현재 창을 닫으시면 작성한 전자서명이 지워집니다. 그래도 닫으시겠습니까?').then(() => {
        this.$refs.signature.initSignaturePad()
        this.signVisible = false
      })
    },
    selWmVisibleClose () {
      this.selWmVisible = false
    }
  }
}
</script>
<style scoped>
.wm-contract-container {
  /*
  <A4 original size(px)>
  width: 798px height: 1128px
  width: 798px height: 1128px
  **/
  width: 600px;
  height: 1200px;
  border: 1px solid gray;
  position: relative;
  /* background-image: url('C:/Users/LENOVO/test/output.jpg'); */
}
</style>
